<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters" class="user-list-filters mb-8">
          <div class="vx-row">
            <div class="vx-col md:w-1/3 sm:w-1/2 w-full mb-5">
              <label class="text-sm opacity-100 text-bold">Search</label>
              <vs-input type="text" v-model="filters['search']" class="w-full" />
            </div>
          </div>
          <div class="vx-row mt-5">
            <div class="vx-col w-full ml-auto">
              <vs-button class="float-right mr-4" size="small" color="danger" type="border" icon-pack="feather"
                v-on:click="filters = {}">CLEAR</vs-button>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card title="CHANNEL PARTNER USERS">
          <template slot="actions">
            <div class="flex">
              <vs-button @click.stop="onClickCreate">Create</vs-button>
            </div>
          </template>
          <div slot="no-body" class="mt-4">
            <vs-table id="suppliers-table" :max-items="(meta.per_page) ? meta.per_page : 10" :data="rm_suppliers"
              @sort="handleSort" :sst="true" stripe class="table-dark-inverted table-auto vs-con-loading__container">>

              <template slot="thead">
                <vs-th width="15%">FIRST NAME</vs-th>
                <vs-th width="15%">LAST NAME</vs-th>
                <vs-th width="15%" class="">EMAIL</vs-th>
                <vs-th width="15%" class="">STATUS</vs-th>
                <vs-th>EMAIL VERIFIED AT</vs-th>
                <vs-th width="15%">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr class="cursor-pointer" @click.native="onClickSupplierView(data[indextr].id)" :key="indextr"
                  v-for="(tr, indextr) in data">

                  <vs-td :data="data[indextr].first_name">
                    {{ data[indextr].first_name || 'N/A' }}
                  </vs-td>

                  <vs-td :data="data[indextr].last_name">
                    {{ data[indextr].last_name || 'N/A' }}
                  </vs-td>

                  <vs-td>
                    {{ data[indextr].email || 'N/A' }}
                  </vs-td>

                  <vs-td>
                    {{ data[indextr].status }}
                  </vs-td>
                  <vs-td>
                    {{ __dateTimeFormatterToDate(data[indextr].email_verified_at)|| 'N/A' }}
                  </vs-td>

                  <vs-td>
                    <div class="vx-row">
                      <!-- <vx-tooltip text="View / Edit" position="left">
                        <vs-button class="mr-2" @click="onClickSupplierView(data[indextr].id)" size="small"
                          color="primary" type="border" icon-pack="feather" icon="icon-eye"></vs-button>
                      </vx-tooltip> -->
                      <vx-tooltip v-if="data[indextr].status === 'Not Invited'" text="Invite & Send welcome email"
                        position="left">
                        <vs-button class="mr-2" @click.stop="onClickSendWelcomeEmail(data[indextr].id, 'invite')"
                          size="small" color="success" type="border" icon-pack="feather" icon="icon-send"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip v-if="data[indextr].status === 'Pending Verification'" text="Resend welcome email"
                        position="left">
                        <vs-button class="mr-2"
                          @click.stop="onClickSendWelcomeEmail(data[indextr].id, 'resend-verify')" size="small"
                          color="success" type="border" icon-pack="feather" icon="icon-rotate-cw"></vs-button>
                      </vx-tooltip>
                      <span class="flex" v-for="(status, status_index) in partners_statuses" :key="status_index">
                        <vs-button size="small" @click.stop="onClickChangeStatus(data[indextr].id, status.name)"
                          v-if="status.before_status.includes(data[indextr].status)" class="mr-2" type="border"
                          :color="status.color">
                          {{ status.label }}
                        </vs-button>
                      </span>
                    </div>
                  </vs-td>
                </vs-tr>
              </template>


            </vs-table>

            <vs-pagination v-on:changeMaxItems="changePage" :size-array="meta.total ? meta.total : 20"
              :max-items="perPage" description-body="Rows per page" description-connector="of"
              description-title="Records" description :description-items="descriptionItems"
              :total="(meta.last_page) ? meta.last_page : 0" v-model="page" class="p-5">
            </vs-pagination>

          </div>
        </vx-card>
      </div>
    </div>
    <CreateChannelPartnerUserPopUp ref="createChannelPartnerUserPopUp" />
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import Filter from '@/mixins/filter';
const ChannelPartnerRepository = RepositoryFactory.get('channel_partner')
import { defaultPagination, perPageList } from "@/constants/config";
import CreateChannelPartnerPopUp from '@/components/popups/tenants/channel-partners/CreateChannelPartnerPopUp.vue';
import CreateChannelPartnerUserPopUp from '@/components/popups/channel-partners/CreateChannelPartnerUserPopUp.vue'
import { partners_statuses } from '@/constants/statuses.js'
import ErrorMessages from '@/mixins/ErrorMessages'
export default {
  name: 'ChannelPartnerUsersList',
  data() {
    return {
      rm_suppliers: [],
      departments: [],
      filters: {},
      page: 1,
      total: 0,
      meta: {},
      sort: '',
      perPage: defaultPagination,
      descriptionItems: perPageList,
      supplier_status_list: [
        { name: 'SAQ Pending', value: 1 },
        { name: 'Pending Approval', value: 2 },
        { name: 'Approved', value: 3 },
        { name: 'Not Approved', value: 4 },
        { name: 'On Hold', value: 5 },
      ],
      partner_id: '',
      partners_statuses: partners_statuses
    }
  },
  components: {
    'v-select': vSelect,
    CreateChannelPartnerPopUp,
    CreateChannelPartnerUserPopUp
  },
  mixins: [Filter, ErrorMessages],
  async mounted() {
    this.partner_id = this.$route.params.partner_id
  },
  methods: {
    async refreshData() {
      this.loadRmSuppliers()
    },

    async loadRmSuppliers() {
      await this.$vs.loading({
        container: '#suppliers-table',
        scale: 0.45
      })
      const { data } = await ChannelPartnerRepository.getChannelPartnerUsers(this.partner_id, this.page, this.filterQuery, this.perPage, this.sort)
      this.rm_suppliers = data.data
      this.meta = data.meta
      this.$vs.loading.close('#suppliers-table > .con-vs-loading')
    },
    async onClickSupplierView(id) {
      this.$router.push({ path: `/pages/channel-partners/${id}` })
    },
    async onClickSendWelcomeEmail(id, status) {
      try {
        await ChannelPartnerRepository.sendUsersWelcomeEmail(id, status)
        await this.loadRmSuppliers()
      } catch (error) {
        this.convertAndNotifyError(error)
      }
    },
    async onClickChangeStatus(id, status_name) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'warning',
        title: 'Confirm',
        text: `Are you sure you want to change partner status?`,
        accept: this.confirmStatusChange,
        parameters: [id, status_name]
      })
    },
    async confirmStatusChange(params) {
      try {
        await ChannelPartnerRepository.changePartnerUserStatus(params[0], params[1])
        await this.loadRmSuppliers()
      } catch (error) {

      }
    },
    filterQueryUpdate() {
      this.loadRmSuppliers()
    },

    handleChangePage(page) {
      this.page = page;
      this.loadRmSuppliers()
    },

    handleSort(key, active) {
      if (key) {
        active = (active === 'desc') ? "-" : '';
        this.sort = active + key;
        this.loadRmSuppliers()
      }
    },
    changePage(index) {
      this.perPage = this.descriptionItems[index]
    },
    async onClickCreate() {
      await this.$refs.createChannelPartnerUserPopUp.openPopup()
    }

  },
  watch: {
    page() {
      this.loadRmSuppliers()
    },
    perPage() {
      this.loadRmSuppliers()
    }
  }
}
</script>
